import type { MetadataRoute } from "next";
import urlJoin from "url-join";
import { z } from "zod";

import { env } from "@/env";

export const additionalLanguageLinksSchema = z.array(
  z.object({
    link: z
      .object({
        model: z.string(),
        value: z.object({
          query: z.array(
            z.union([
              z.object({
                property: z.literal("urlPath"),
                operator: z.literal("is"),
                value: z.union([z.array(z.string()), z.string()]),
              }),
              z.object({
                property: z.literal("locale"),
                operator: z.literal("is"),
                value: z.array(z.string()),
              }),
            ])
          ),
        }),
      })
      .passthrough(),
  })
);

export type AdditionalLanguageLinks = z.infer<typeof additionalLanguageLinksSchema>;

export const getAlternates = (
  additionalLanguageLinks: unknown
): NonNullable<MetadataRoute.Sitemap[number]["alternates"]> | undefined => {
  if (!additionalLanguageLinks) {
    return undefined;
  }

  const parsed = additionalLanguageLinksSchema.safeParse(additionalLanguageLinks);

  if (!parsed.success) {
    return undefined;
  }

  const languages: Record<string, string> = {};

  for (const item of parsed.data) {
    const query = item.link.value.query;
    const urlPath = query.find(({ property }) => property === "urlPath")?.value;
    const locale = query.find(({ property }) => property === "locale")?.value?.[0];

    if (locale) {
      const urls = Array.isArray(urlPath) ? urlPath : [urlPath];
      urls.forEach((urlPath) => {
        if (urlPath) {
          languages[locale] = urlJoin(env.siteUrl, locale, urlPath);
        }
      });
    }
  }

  return Object.keys(languages).length > 0 ? { languages } : undefined;
};
